import util from '../util'

let controller = 'Subparceiro'

export default Object.assign({}, util.GetCrud(controller, null), {
  Listar: function (dto) {
    return util.Axios.GetAll(controller, dto)
  },
  Historico: function (dto, options){
    if (options && options.data) dto.data = options.data
    return util.Axios.GetAll(controller + '/historico', dto)
  }
})
